<template>
  <div class="modal fade show" style="display: block">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header bg-light p-3">
          <h5 class="modal-title">{{ formTitle }}</h5>
          <button type="button" class="btn-close" @click="handleClose"></button>
        </div>
        <form>
          <div class="modal-body">
            <div class="row gy-4 mb-3">
              <div class="col-12">
                <label for="name-field" class="form-label"
                  ><span class="text-danger">*</span>维护保养名称</label
                >
                <Multiselect
                  v-model="form.maintenance_name"
                  :loading="equipSelectLoading"
                  :close-on-select="true"
                  :searchable="true"
                  :canClear="true"
                  :create-option="true"
                  :options="equipmentList"
                  :class="{
                    'is-invalid': submitted && v$.form.maintenance_name.$error,
                  }"
                  @change="equipmentChanged($event)"
                />
                <div
                  v-if="submitted && v$.form.maintenance_name.$error"
                  class="invalid-feedback"
                >
                  <span v-if="v$.form.maintenance_name.required.$message">{{
                    v$.form.maintenance_name.required.$message
                  }}</span>
                </div>
              </div>
            </div>
            <div class="row gy-4 mb-3">
              <div class="col-12">
                <label for="start-field" class="form-label"
                  ><span class="text-danger">*</span>设备</label
                >
                <input
                  type="text"
                  class="form-control"
                  v-model="form.equipment_name"
                  :class="{
                    'is-invalid': submitted && v$.form.equipment_name.$error,
                  }"
                  required
                  disabled
                />
                <div
                  v-if="submitted && v$.form.equipment_name.$error"
                  class="invalid-feedback"
                >
                  <span v-if="v$.form.equipment_name.required.$message">{{
                    v$.form.equipment_name.required.$message
                  }}</span>
                </div>
              </div>
            </div>
            <div class="row gy-4 mb-3">
              <div class="col-12">
                <label for="start-field" class="form-label"
                  ><span class="text-danger">*</span>维护项目</label
                >
                <Multiselect
                  mode="tags"
                  v-model="form.items"
                  :loading="maintItemsSelectLoading"
                  :close-on-select="true"
                  :searchable="true"
                  :canClear="true"
                  :options="itemsList"
                  :class="{ 'is-invalid': submitted && v$.form.items.$error }"
                  @change="groupChanged($event)"
                />
                <div
                  v-if="submitted && v$.form.items.$error"
                  class="invalid-feedback"
                >
                  <span v-if="v$.form.items.required.$message">{{
                    v$.form.items.required.$message
                  }}</span>
                </div>
              </div>
            </div>
            <div class="row gy-4 mb-3">
              <div class="col-12">
                <label for="start-field" class="form-label"
                  ><span class="text-danger">*</span>维护周期</label
                >
                <Multiselect
                  v-model="form.cycle"
                  :close-on-select="true"
                  :searchable="true"
                  :canClear="false"
                  :options="cycleList"
                  :class="{ 'is-invalid': submitted && v$.form.cycle.$error }"
                />
                <div
                  v-if="submitted && v$.form.cycle.$error"
                  class="invalid-feedback"
                >
                  <span v-if="v$.form.cycle.required.$message">{{
                    v$.form.cycle.required.$message
                  }}</span>
                </div>
              </div>
            </div>
            <div class="row gy-4 mb-3">
              <div class="col-6">
                <label for="start-field" class="form-label"
                  ><span class="text-danger">*</span>开始时间</label
                >
                <flat-pickr
                  v-model="form.starts"
                  :config="dateConfig"
                  class="form-control flatpickr-input"
                  :class="{ 'is-invalid': submitted && v$.form.starts.$error }"
                ></flat-pickr>
                <div
                  v-if="submitted && v$.form.starts.$error"
                  class="invalid-feedback"
                >
                  <span v-if="v$.form.starts.required.$message">{{
                    v$.form.starts.required.$message
                  }}</span>
                </div>
              </div>
            </div>
            <div class="row gy-4 mb-3" v-show="form.cycle != 'nothing'">
              <div class="col-12">
                <label for="period-field" class="form-label">周期截止至</label>
                <div class="d-flex">
                  <div class="flex-1">
                    <Multiselect
                      v-model="form.cycletype"
                      :close-on-select="true"
                      :searchable="false"
                      :canClear="false"
                      :options="cycleTypeList"
                      class="form-control"
                    />
                  </div>
                  <div class="flex-1 ms-4">
                    <div v-if="form.cycletype && form.cycletype == 2">
                      <flat-pickr
                        v-model="form.ends"
                        :config="dateConfig1"
                        class="form-control flatpickr-input"
                      ></flat-pickr>
                    </div>
                    <input
                      v-if="form.cycletype && form.cycletype == 3"
                      type="number"
                      class="form-control"
                      :class="{ 'is-invalid': submitted && numTip }"
                      v-model="form.num"
                    />
                    <div v-if="submitted && numTip" class="invalid-feedback">
                      <span>{{ numTip }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row gy-4 mb-3">
              <div class="col-12">
                <label for="comment-field" class="form-label">资料</label>
                <DropZone
                  @drop.prevent="drop"
                  @change="selectedFile"
                  style="min-height: 220px"
                  limit="50M"
                />
                <ul
                  class="list-unstyled mb-0"
                  id="dropzone-preview"
                  v-if="form.attachments"
                >
                  <div
                    class="border rounded"
                    v-for="(file, index) of form.attachments"
                    :key="index"
                  >
                    <div class="d-flex p-2">
                      <div class="flex-grow-1">
                        <div class="pt-1">
                          <h5 class="fs-14 mb-1">
                            <a
                              :href="file.url"
                              :download="file.url"
                              class="text-break"
                            >
                              {{ filterName(file.objectName) }}
                            </a>
                          </h5>
                          <p class="fs-13 text-muted mb-0">
                            <strong>{{ file.size / 1024 }}</strong> KB
                          </p>
                        </div>
                      </div>
                      <div class="flex-shrink-0 ms-3">
                        <button
                          type="button"
                          class="btn btn-sm btn-danger"
                          @click="deleteFile(index)"
                        >
                          删除
                        </button>
                      </div>
                    </div>
                  </div>
                </ul>
              </div>
            </div>
            <div class="row gy-4 mb-3">
              <div class="col-12">
                <label for="operator-field" class="form-label">操作人员</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="form.assignee"
                  required
                />
              </div>
            </div>
            <div class="row gy-4 mb-3">
              <div class="col-12">
                <label for="comment-field" class="form-label">备注</label>
                <textarea
                  rows="3"
                  class="form-control"
                  v-model="form.summary"
                />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="hstack gap-2 justify-content-end">
              <button type="button" class="btn btn-light" @click="handleClose">
                取消
              </button>
              <button
                type="button"
                class="btn btn-primary"
                id="add-btn"
                @click="handleSubmit"
              >
                确认
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div class="modal-backdrop fade show"></div>
</template>
<script>
import Swal from "sweetalert2";
import { required, helpers } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";
import "@/default.scss";
import _ from "loadsh";
import moment from "moment";
import DropZone from "@/components/widgets/dropZone";
import axios from "axios";
import { v4 as uuidv4 } from "uuid";
import { imageCompress } from "@/utils/common.js";

import {
  getInstancesDetailId,
  // getMaintenances,
  createMaintenTasks,
  editMaintenTasks,
  getUploadFileSign,
  getUploadFileDetail,
} from "@/service/index.js";
import { cycleList, cycleTypeList } from "../utils";

export default {
  emits: ["update:isShowAddForm", "handleAlert", "handleGetTasks"],
  props: {
    date: Object,
    isShowAddForm: Boolean,
    formType: {
      type: String,
      default: "add",
    },
    singleData: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  setup() {
    return { v$: useVuelidate() };
  },
  validations: {
    form: {
      maintenance_name: {
        required: helpers.withMessage("维护保养名称为必填项", required),
      },
      equipment_name: {
        required: helpers.withMessage("设备为必填项", required),
      },
      items: {
        required: helpers.withMessage("维护选项为必填项", required),
      },
      cycle: {
        required: helpers.withMessage("维护周期为必填项", required),
      },
      starts: {
        required: helpers.withMessage("开始时间为必填项", required),
      },
    },
  },
  components: {
    DropZone,
    Multiselect,
  },
  data() {
    return {
      form: {},
      //选择时显示的时间
      dateConfig: {
        altFormat: "Y-m-d",
        altInput: true,
        dateFormat: "Y-m-d",
        disable: [],
      },
      dateConfig1: {
        //选择结束时间
        altFormat: "Y-m-d", //选择时显示的时间
        altInput: true,
        dateFormat: "Y-m-d",
      },
      cycleTypeList: cycleTypeList,
      cycleList: cycleList,
      equipmentList: [],
      itemsList: [],
      itemsListClone: [],
      repairsList: [],
      submitted: false,
      equipSelectLoading: false,
      maintItemsSelectLoading: false,
      numTip: "",
      fileMaxSize: 1024 * 1024 * 50,
      fileType: [
        ".ppt",
        ".pptx",
        ".pdf",
        ".xlsx",
        ".xls",
        ".docx",
        ".doc",
        ".PNG",
        ".png",
        ".JPEG",
        ".jpeg",
        ".MP4",
        ".mp4",
        ".MOV",
        ".mov",
      ],
    };
  },
  watch: {
    singleData: {
      handler(val) {
        this.form = _.cloneDeep(val);
      },
      deep: true,
      immediate: true,
    },
    "form.equipment_id": {
      handler(val) {
        if (val) {
          let info = this.equipmentList.find((item) => {
            return item.id === val;
          });
          if (info) {
            this.form.equipment_name = info.name;
          }
        }
      },
      deep: true,
      immediate: true,
    },
    "form.cycletype": {
      handler() {
        if (this.formType === "edit") return;
        this.form.ends = this.form.num = null;
      },
      deep: true,
      immediate: true,
    },
    "form.cycle": {
      handler(val) {
        let arr = ["w7", "w1", "w2", "w3", "w4", "w5", "w6"];
        if (!arr.includes(val)) {
          if (this.dateConfig.disable.length) {
            this.form.starts = null;
            this.dateConfig.disable = [];
          }
        } else {
          this.dateConfig.disable = [
            function (date) {
              return date.getDay() !== _.indexOf(arr, val);
            },
          ];
          if (new Date(this.form.starts).getDay() !== _.indexOf(arr, val))
            this.form.starts = null;
        }
      },
      deep: true,
      immediate: true,
    },
    "form.ends": {
      handler() {
        if (this.form.starts) {
          this.dateConfig1.minDate = this.form.starts;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    formTitle() {
      return this.formType === "edit" ? "编辑保养任务" : "新增保养任务";
    },
  },
  created() {
    if (this.formType == "add") {
      this.handleGetEquipList();
    } else {
      this.handleGetEquipList(this.singleData.equipment_id);
    }
  },
  methods: {
    moment,
    filterMaintenceItems(items) {
      if (!items.length) return [];
      let newItems = [];
      items.forEach((item) => {
        let info = this.itemsList.find((ele) => {
          return ele == item;
        });
        if (info) {
          let obj = { name: info };
          if (this.formType == "edit") {
            let data = this.form.originItems.find((ele) => {
              return ele == item;
            });
            obj.status = data ? data.status : 0;
          } else {
            obj.status = 0;
          }
          newItems.push(obj);
        }
      });
      return newItems;
    },
    handleClose() {
      this.$emit("update:isShowAddForm", false);
    },
    /* 提交 */
    handleSubmit() {
      this.numTip = "";
      this.submitted = true;
      this.v$.$touch();
      if (this.v$.$invalid) return;

      if (
        this.form.cycle != "nothing" &&
        this.form.cycletype &&
        this.form.cycletype == "3"
      ) {
        //给周期数添加校验
        if (!(this.form.num && /^([1-9][0-9]*)$/.test(this.form.num))) {
          this.numTip = "Please enter positive integer";
          return;
        }
      }

      if (this.form.cycle == "nothing") {
        this.form.repeat = "once";
      }
      if (this.form.cycle == "da") {
        this.form.repeattype = "days";
        this.form.repeat = "daily";
      }
      if (this.form.cycle.indexOf("w") > -1) {
        this.form.repeattype = "weeks";
        this.form.repeat = "weekly";
      }
      if (this.form.cycle.indexOf("m") > -1) {
        this.form.repeattype = "months";
        this.form.repeat = "monthly";
      }
      if (this.form.cycle.indexOf("y") > -1) {
        this.form.repeattype = "years";
        this.form.repeat = "yearly";
      }
      var numtype = {
        nothing: 1,
        da: 1,
        w: 1,
        m: 1,
        y: 1,
        m3: 3,
        m6: 6,
        ws2: 2,
        w1: 1,
        w2: 1,
        w3: 1,
        w4: 1,
        w5: 1,
        w6: 1,
        w7: 1,
      };
      if (this.form.cycletype == 3) {
        this.form.ends = moment(this.form.starts)
          .add(
            this.form.num * numtype[this.form.cycle] - 1,
            this.form.repeattype
          )
          .format("YYYY-MM-DD");
      }
      var properties = {
        equipment_name: this.form.equipment_name,
        equipment_id: this.form.equipment_id,
        maintenceItems: this.filterMaintenceItems(this.form.items),
        cycle: this.form.cycle,
        cycletype: this.form.cycletype,
        num: parseInt(this.form.num),
        time: moment().format("HH:mm:ss"),
        status: 0,
        end_repeat:
          this.form.ends && moment(this.form.ends).format("YYYY-MM-DD"),
        attachments: this.form.attachments,
      };
      var params = {
        title: this.form.maintenance_name,
        repeat: this.form.repeat,
        starts: moment(this.form.starts).format("YYYY-MM-DD"),
        assignee: this.form.assignee,
        summary: this.form.summary,
        repeat_step: numtype[this.form.cycle],
        equipment_id: this.form.equipment_id,
      };
      if (
        this.form.cycle != "nothing" &&
        this.form.cycletype &&
        this.form.cycletype != "1"
      ) {
        params.ends = moment(this.form.ends).format("YYYY-MM-DD");
      }
      if (this.form.cycle == "nothing") {
        properties.num = null;
        properties.cycletype = null;
        properties.end_repeat = null;
      }

      if (this.formType === "edit") {
        (params.edit_date = this.singleData.starts),
          Swal.fire({
            width: this.form.cycle == "nothing" ? 500 : 700,
            icon: "warning",
            title:
              this.form.cycle == "nothing"
                ? "是否要修改此任务?"
                : "是要修改此任务以及此任务将重复的所有未来任务，还是仅修改此选定任务?",
            showDenyButton: this.form.cycle != "nothing",
            showCancelButton: true,
            cancelButtonColor: "#f46a6a",
            confirmButtonColor: "#34c38f",
            cancelButtonText: "取消",
            denyButtonColor: "#34c38f",
            confirmButtonText:
              this.form.cycle == "nothing" ? "是，修改它" : "仅修改此任务",
            denyButtonText: `修改所有未来定期任务`,
          }).then((result) => {
            if (result.isConfirmed || result.isDenied) {
              params.mode = result.isConfirmed
                ? "this"
                : result.isDenied
                ? "features"
                : "this";
              properties.end_repeat =
                params.mode == "this" ? this.form.starts : this.form.ends;
              if (
                this.singleData.cycle == "nothing" &&
                this.singleData.cycle != this.form.cycle
              ) {
                properties.end_repeat = this.form.ends;
              }
              params.properties = JSON.stringify(properties);
              editMaintenTasks(this.form.id, params)
                .then((res) => {
                  if (
                    res &&
                    _.get(res, ["meta", "code"]) === 0 &&
                    res.payload
                  ) {
                    this.$emit(
                      "handleAlert",
                      "success",
                      "修改成功!",
                      "ri-check-double-line",
                      1000
                    );
                    this.$emit("handleGetTasks", this.date);
                    this.handleClose();
                  } else {
                    this.$emit("handleAlert", "danger", "请求失败，请重试!");
                  }
                })
                .catch((err) => {
                  this.$emit(
                    "handleAlert",
                    "danger",
                    err.message || "请求失败，请重试!"
                  );
                });
            }
          });
      } else {
        params.properties = JSON.stringify(properties);
        createMaintenTasks(params)
          .then((res) => {
            if (res && _.get(res, ["meta", "code"]) === 0 && res.payload) {
              this.$emit(
                "handleAlert",
                "success",
                "新增成功!",
                "ri-check-double-line",
                1000
              );
              this.$emit("handleGetTasks", this.date);
              this.handleClose();
            }
          })
          .catch((err) => {
            this.$emit(
              "handleAlert",
              "danger",
              err.message || "请求失败，请重试!"
            );
          });
      }
    },
    /* 选择维护名称操作 */
    equipmentChanged(val) {
      this.form.items = [];
      this.itemsList = [];
      let filterList = _.cloneDeep(this.repairsList);
      let filter;
      filter = filterList.filter((list) => {
        return [...list.names].includes(val);
      });
      if (filter.length) {
        this.filterEquipGroup(filterList, val);
      } else {
        this.itemsList = _.cloneDeep(this.itemsListClone);
      }
    },
    filterEquipGroup(list, val) {
      list.forEach((l) => {
        l.names.forEach((a) => {
          if (a == val) {
            this.form.items.push(l.item);
            this.itemsList.push(l.item);
          }
        });
      });
    },
    /* 维护项目操作 */
    groupChanged(val) {
      if (val.length) {
        return;
      }
      this.form.maintenance_name = "";
      this.itemsList = _.cloneDeep(this.itemsListClone);
    },
    /* 获取设备信息 */
    handleGetEquipList(id) {
      this.equipSelectLoading = true;
      let params = {
        id: id || this.$route.query.equip_id,
      };
      getInstancesDetailId(params)
        .then((res) => {
          if (res && _.get(res, ["meta", "code"]) == 200 && res.payload) {
            this.form.equipment_name = res.payload.name;
            this.form.equipment_id = res.payload.id;
            let nameList = [];
            this.repairsList = res.payload.repairs;
            res.payload.repairs.forEach((repair) => {
              nameList.push(...repair.names);
              this.itemsList.push(repair.item);
              this.itemsListClone.push(repair.item);
            });
            /* 编辑状态 */
            if (this.formType == "edit") {
              this.itemsList = [];
              this.repairsList.forEach((repair) => {
                if ([...repair.names].includes(this.form.maintenance_name)) {
                  this.itemsList.push(repair.item);
                } else {
                  this.itemsList = this.itemsListClone;
                }
              });
            }
            this.equipmentList = [...new Set(nameList)]; //去重
            // 自定义添加的名称处理
            if (
              this.form.maintenance_name &&
              ![...this.equipmentList].includes(this.form.maintenance_name)
            ) {
              this.equipmentList.push(this.form.maintenance_name);
            }
            this.equipSelectLoading = false;
          }
        })
        .catch((err) => {
          this.equipSelectLoading = false;
          this.$emit(
            "handleAlert",
            "danger",
            err.message || "请求失败，请重试！"
          );
        });
    },
    // start--上传文件相关事件
    async selectedFile() {
      let dropzoneFile = document.querySelector(".dropzoneFile").files[0];
      if (!dropzoneFile) return;
      let suffix = dropzoneFile.name.substring(
        dropzoneFile.name.lastIndexOf(".")
      );
      if (!this.fileType.includes(suffix)) {
        this.$emit("handleAlert", "danger", "文件类型不符合!");
        document.querySelector(".dropzoneFile").value = "";
        return;
      }
      if (dropzoneFile.size > this.fileMaxSize) {
        this.$emit("handleAlert", "danger", "文件大小不能超过50M!");
        document.querySelector(".dropzoneFile").value = "";
        return;
      }
      if (/\.(png|jpeg|jpg)$/.test(suffix)) {
        let file = await imageCompress(dropzoneFile);
        this.uploadFileSign(file);
      } else {
        this.uploadFileSign(dropzoneFile);
      }
    },
    uploadFileSign(file) {
      Swal.fire({ title: "上传中...", showConfirmButton: false });
      Swal.showLoading();
      let filename = file.name;
      let objectName = `events/${uuidv4()}/${filename}`;
      let params = {
        object: objectName,
        method: "upload",
      };
      getUploadFileSign(params).then((res) => {
        if (res && res.payload) {
          axios
            .put(res.payload.signedUrl, file)
            .then(() => {
              let params = {
                object: objectName,
              };
              Swal.close();
              this.$emit(
                "handleAlert",
                "success",
                "上传文件成功!",
                "ri-check-double-line"
              );
              getUploadFileDetail(params).then((detail) => {
                if (detail && detail.payload) {
                  this.form.attachments = this.form.attachments
                    ? this.form.attachments
                    : [];
                  this.form.attachments.push(detail.payload);
                  document.getElementById("dropzoneFile").value = "";
                }
              });
            })
            .catch((err) => {
              Swal.close();
              this.$emit(
                "handleAlert",
                "danger",
                err.message || "上传失败，请重试!"
              );
            });
        }
      });
    },
    async drop(e) {
      let dropzoneFile = e.dataTransfer.files[0];
      if (!dropzoneFile) return;
      let suffix = dropzoneFile.name.substring(
        dropzoneFile.name.lastIndexOf(".")
      );
      if (!this.fileType.includes(suffix)) {
        this.$emit("handleAlert", "danger", "文件类型不符合!");
        document.querySelector(".dropzoneFile").value = "";
        return;
      }
      if (dropzoneFile.size > this.fileMaxSize) {
        this.$emit("handleAlert", "danger", "文件大小不能超过50M!");
        document.querySelector(".dropzoneFile").value = "";
        return;
      }
      if (/\.(png|jpeg|jpg)$/.test(suffix)) {
        let file = await imageCompress(dropzoneFile);
        this.uploadFileSign(file);
      } else {
        this.uploadFileSign(dropzoneFile);
      }
    },
    deleteFile(i) {
      this.form.attachments.splice(i, 1);
    },
    // end---上传文件相关事件
    filterName(name) {
      if (/^(device\/)/.test(name)) {
        return name.substring(44);
      } else if (/^(reports\/)/.test(name)) {
        return name.substring(45);
      } else if (/^(events\/)/.test(name)) {
        return name.substring(44);
      } else {
        return name;
      }
    },
  },
};
</script>
<style lang="scss">
.multiselect-tag {
  white-space: normal !important;
}
</style>
